export default "__VITE_ASSET__qxzCuoaq__"